import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  FaCheckCircle,
  FaHome,
  FaEnvelope,
  FaShoppingBag,
  FaGraduationCap,
} from "react-icons/fa";

import MainContainer from "../../components/MainContainer/MainContainer";
import SEO from "../../components/SEO/SEO";
import { clearCart } from "../../store/slices/cart/asyncThunks";
import paymentService from "../../api/services/payment";
import {
  Container,
  SuccessHeader,
  SuccessIcon,
  SuccessTitle,
  SuccessMessage,
  OrderDetails,
  OrderSection,
  SectionTitle,
  OrderInfo,
  InfoRow,
  InfoLabel,
  InfoValue,
  ActionButtons,
  PrimaryButton,
  SecondaryButton,
  NextSteps,
  StepCard,
  StepIcon,
  StepContent,
} from "../OrderSuccessPage/OrderSuccessPage.styles";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const orderNumber = searchParams.get("orderNumber");
  const [orderStatus, setOrderStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigateWithScroll = (path) => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  };

  useEffect(() => {
    // Clear cart on successful payment
    dispatch(clearCart());
    localStorage.removeItem("checkoutData");

    // Check order status
    const checkStatus = async () => {
      if (orderNumber) {
        try {
          const response = await paymentService.checkPaymentStatus(orderNumber);
          setOrderStatus(response.order);
        } catch (error) {
          console.error("Failed to check order status:", error);
        }
      }
      setLoading(false);
    };

    checkStatus();
  }, [orderNumber, dispatch]);

  if (loading) {
    return (
      <MainContainer>
        <Container>
          <SuccessMessage>Proveravam status porudžbine...</SuccessMessage>
        </Container>
      </MainContainer>
    );
  }

  return (
    <MainContainer>
      <SEO title="Uspešna porudžbina" path="/uspesna-porudzbina" noindex />

      <Container>
        <SuccessHeader>
          <SuccessIcon>
            <FaCheckCircle />
          </SuccessIcon>
          <SuccessTitle>Plaćanje Uspešno!</SuccessTitle>
          <SuccessMessage>
            Vaša porudžbina <strong>#{orderNumber}</strong> je uspešno plaćena.
            Hvala vam na poverenju!
          </SuccessMessage>
        </SuccessHeader>

        <OrderDetails>
          <OrderSection>
            <SectionTitle>
              <FaEnvelope />
              Potvrda Plaćanja
            </SectionTitle>
            <OrderInfo>
              <InfoRow>
                <InfoLabel>Broj Porudžbine:</InfoLabel>
                <InfoValue>#{orderNumber}</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel>Datum Plaćanja:</InfoLabel>
                <InfoValue>
                  {new Date().toLocaleDateString("sr-Latn-RS", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </InfoValue>
              </InfoRow>
              {orderStatus && (
                <>
                  <InfoRow>
                    <InfoLabel>Status:</InfoLabel>
                    <InfoValue className="status-completed">
                      {orderStatus.paymentStatus === "completed"
                        ? "Plaćeno"
                        : orderStatus.paymentStatus}
                    </InfoValue>
                  </InfoRow>
                  <InfoRow>
                    <InfoLabel>Iznos:</InfoLabel>
                    <InfoValue className="total">
                      {Number(orderStatus.total).toLocaleString("sr-latn-RS")}{" "}
                      {orderStatus.currency}
                    </InfoValue>
                  </InfoRow>
                </>
              )}
            </OrderInfo>
          </OrderSection>

          <OrderSection>
            <SectionTitle>
              <FaEnvelope />
              Email Potvrda
            </SectionTitle>
            <SuccessMessage
              style={{ textAlign: "left", margin: 0, fontSize: "16px" }}
            >
              Potvrda porudžbine je poslata na vašu email adresu. Proverite i
              spam folder ako ne vidite email.
            </SuccessMessage>
          </OrderSection>
        </OrderDetails>

        <NextSteps>
          <SectionTitle>Sledeći Koraci</SectionTitle>
          <div className="steps-grid">
            <StepCard>
              <StepIcon>
                <FaEnvelope />
              </StepIcon>
              <StepContent>
                <h4>1. Proverite Email</h4>
                <p>
                  Poslali smo vam potvrdu plaćanja sa detaljima transakcije.
                </p>
              </StepContent>
            </StepCard>

            <StepCard>
              <StepIcon>
                <FaGraduationCap />
              </StepIcon>
              <StepContent>
                <h4>2. Pristupite Kursevima</h4>
                <p>
                  Vaši kursevi su već dostupni u vašem profilu. Možete odmah
                  početi sa učenjem.
                </p>
              </StepContent>
            </StepCard>

            <StepCard>
              <StepIcon>
                <FaShoppingBag />
              </StepIcon>
              <StepContent>
                <h4>3. Bezbednost</h4>
                <p>
                  Vaša transakcija je bezbedno obrađena putem Raiffeisen banke.
                </p>
              </StepContent>
            </StepCard>
          </div>
        </NextSteps>

        <ActionButtons>
          <PrimaryButton
            onClick={() => navigateWithScroll("/korisnicki-panel/kursevi")}
          >
            <FaGraduationCap />
            Idite na Moje Kurseve
          </PrimaryButton>
          <SecondaryButton onClick={() => navigateWithScroll("/")}>
            <FaHome />
            Povratak na Početnu
          </SecondaryButton>
        </ActionButtons>
        {/* 
        <ContactInfo>
          <h3>Potrebna vam je pomoć?</h3>
          <div className="contact-subtitle">
            Kontaktirajte nas ako imate bilo kakva pitanja o vašoj porudžbini.
          </div>
          <div className="contact-grid">
            <div className="contact-item">
              <FaEnvelope />
              <div>
                <strong>Email Podrška</strong>
                <p>info@mitovka.com</p>
              </div>
            </div>
          </div>
        </ContactInfo> */}
      </Container>
    </MainContainer>
  );
};

export default PaymentSuccess;
